/* global define */

// angular, jquery, etc. are modules defined in the project requireConfig
// js files for this module must include the ./ to be relative to this module
// and must include the file extension (.js)
// CSS and other related files can use relative paths but must have file extensions
define('paychex.app.messages/drawer/messageDetail/module',[
    'angular',
    'jquery',
    'paychex.app.common/services',
    'paychex.app.common/globalFrameUI/module',
    'paychex.app.messages/drawer/messageDetail/Constants',
    'paychex.app.messages/services/module',
    'paychex.app.messages/drawer/messageDetail/MessageDetailController'
], function (angular,
             jquery,
             pacServicesModule,
             drawerManagerModule,
             Constants,
             MessageServiceModule,
             MessageDetailController) {
    'use strict';

    return angular.module('paychex.app.drawer.messageDetail', [
        pacServicesModule.name,
        MessageServiceModule.name,
        drawerManagerModule.name
    ])
        .controller(Constants.messageDetailControllerName, MessageDetailController);
});

